module.exports = __webpack_public_path__ + "static/media/silent_chat_on.1515489e.svg";